import screenerSlice, {
  screenerEffects,
  screenerSelectors,
} from 'features/screener/slice';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@deprecated-ui/screener/Radio';
import { IDataScreenerFavorites } from 'features/screener/types';
import styled from 'styled-components';

const FavoritesBarContainer = styled.div`
  display: inline-block;
  max-width: 86%;
  height: 32px;
  overflow: hidden;

  label > span:nth-child(2) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const FavoritesBar = () => {
  // prettier-ignore
  const [listFavorites, setListFavorites] = useState<IDataScreenerFavorites[]>([]);
  const [activeFavoritesID, setActiveFavoritesID] = useState<number>(0);
  const {
    screenerFavorites,
    screenerResult: {
      data: { screenerid },
    },
  } = useSelector(screenerSelectors);

  const dispatch = useDispatch();
  const {
    actions: { setIsFormActive, setIsFormCreateMode, setIsFormEditMode },
  } = screenerSlice;

  const visibleFavoritesScreener = listFavorites;

  const onSelectFavoritesHandler = (values) => {
    const {
      target: { presetType, value },
    } = values;

    setActiveFavoritesID(value);

    dispatch(
      screenerEffects.getScreener({
        screenerID: value,
        type: presetType,
      }),
    );

    dispatch(setIsFormActive(false));
    dispatch(setIsFormCreateMode(false));
    dispatch(setIsFormEditMode(false));
  };

  useEffect(() => {
    const { data } = screenerFavorites;

    setListFavorites(data);
  }, [screenerFavorites]);

  useEffect(() => {
    if (listFavorites.length && activeFavoritesID === 0) {
      const { id, type } = listFavorites[0];
      dispatch(
        screenerEffects.getScreener({
          screenerID: id,
          type,
        }),
      );
    }
  }, [listFavorites]);

  useEffect(() => {
    if (screenerid) {
      setActiveFavoritesID(screenerid);
    }
  }, [screenerid]);

  return (
    <FavoritesBarContainer>
      <Radio.Group
        defaultValue={activeFavoritesID}
        onChange={onSelectFavoritesHandler}
        value={activeFavoritesID}
      >
        {visibleFavoritesScreener.map(({ name, id, type }) => {
          const showedName = name?.length > 50 ? `${name?.substring(0, 50)}...` : name;
          return (
            // @ts-expect-error
            <Radio.Button value={id} key={id} presetType={type}>
              {showedName}
            </Radio.Button>
          );
        })}
      </Radio.Group>
    </FavoritesBarContainer>
  );
};

export default FavoritesBar;
